import { render, staticRenderFns } from "./DividerTitle.vue?vue&type=template&id=64e09398&scoped=true&"
import script from "./DividerTitle.vue?vue&type=script&lang=js&"
export * from "./DividerTitle.vue?vue&type=script&lang=js&"
import style0 from "./DividerTitle.vue?vue&type=style&index=0&id=64e09398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e09398",
  null
  
)

export default component.exports